import { Controller, useFormContext } from "react-hook-form";

import { Select } from "ui/select";
import ContentPadding from "containers/admin/clients/client/theme-page/preview/sub-tabs/layout/components/content-padding";
import { Accordion } from "ui/accordion";

import { useThemePreviewContext } from "containers/admin/clients/client/theme-page/contexts/theme-preview-context";

import { CustomSelectOption } from "containers/admin/clients/client/theme-page/preview/preview.types";
import {
  LAYOUT_DEFAULT,
  BLOCK_TYPES,
} from "containers/admin/clients/client/theme-page/preview/sub-tabs/layout/layout.constants";

const ContentBlockPadding = () => {
  const { isEditMode, setLayout } = useThemePreviewContext();
  const { control, watch, setValue, clearErrors } = useFormContext();

  // Watch the current value to determine which content to show
  const selectedOption = watch("layout.contentBlock.group");

  // Options for the select dropdown
  const groupOptions: CustomSelectOption[] = [
    { label: "All content blocks", value: "all-blocks" },
    { label: "Custom", value: "custom" },
  ];

  // Helper to reset custom values to defaults
  const resetCustomVals = (section: string) => {
    setValue(`layout.contentBlock.${section}`, LAYOUT_DEFAULT);
    clearErrors(`layout.contentBlock.${section}`);

    setLayout((prev: any) => {
      if (!prev) return prev;
      return {
        ...prev,
        contentBlock: {
          ...prev.contentBlock,
          [section]: {
            ...LAYOUT_DEFAULT,
          },
        },
      };
    });
  };

  const handleChange = (
    input: CustomSelectOption,
    fieldOnChange: (value: CustomSelectOption) => void,
  ) => {
    const { label, value } = input;

    // Reset values when switching between all-blocks and custom
    if (value === "all-blocks") {
      BLOCK_TYPES.forEach((section) => {
        resetCustomVals(section);
      });
    } else if (value === "custom") {
      resetCustomVals("allBlocks");
    }

    setLayout((prev: any) => {
      if (!prev) return prev;
      return {
        ...prev,
        contentBlock: {
          ...prev.contentBlock,
          group: { label, value },
        },
      };
    });

    fieldOnChange({ label, value });
  };

  return (
    <div>
      {/* Select dropdown */}
      <div className="mb-4">
        <Controller
          name="layout.contentBlock.group"
          control={control}
          render={({ field }) => (
            <Select
              ariaLabel="Select content block type"
              selectName="content-block-group-select"
              disableClearable
              options={groupOptions}
              required={false}
              disabled={!isEditMode}
              {...field}
              value={field.value}
              onChange={(el) => {
                if (el) {
                  handleChange(el, field.onChange);
                }
              }}
            />
          )}
        />
      </div>

      {/* Conditional rendering based on selection */}
      {selectedOption?.value === "all-blocks" ? (
        <ContentPadding sectionName={"layout.contentBlock.allBlocks"} />
      ) : (
        <div className="space-y-4">
          <Accordion title="Headings">
            <ContentPadding sectionName="layout.contentBlock.headings" />
          </Accordion>
          <Accordion title="Paragraph">
            <ContentPadding sectionName="layout.contentBlock.paragraph" />
          </Accordion>
          <Accordion title="Button">
            <ContentPadding sectionName="layout.contentBlock.button" />
          </Accordion>
        </div>
      )}
    </div>
  );
};

export default ContentBlockPadding;
